import auth from './auth'
import dashboard from './dashboard'
import properties from './properties'
import graph from './graph'
import monitoring from './monitoring'
import rules from './rules'
import bindings from './bindings'
import schema from './schema'
import lists from './lists'
import system from './system';

export default {
	auth,
	dashboard,
	properties,
	graph,
	monitoring,
	rules,
	bindings,
	schema,
	lists,
	system
}
